
import React, { useEffect, useState, useRef } from 'react';
 import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
 
const MonthAbstract_Data = async (parms) => {
    
  const response = await fetch(`${process.env.REACT_APP_URL_SIDE}/sdms/Month_Trans_Report`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(parms),
  });
  if (!response.ok) {
    throw new Error('Failed to fetch data');
  }
  
  return response.json();
};

const MonthAbstract_cards = ({ month, year }) => {

  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [tabHeading, setTabHeading] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const monthcardstab = useRef(null); // Use ref to scroll to this div
 
  useEffect(() => {
    const getData = async () => {
      try {
        const response_data = await MonthAbstract_Data({ month, year});
        setTabHeading(response_data.heading);

        if (response_data.data && response_data.data.length > 0) {
          setReportData(response_data.data);

        } else {
          setReportData([]);
        }
      } catch (errorr) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    getData();
  }, [month, year]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (value) => {
    setRowsPerPage(value === 'all' ? reportData.length : parseInt(value, 10));
    setPage(0); // Reset page to 0 when changing rows per page
  };


  useEffect(() => {
    if (!loading && !error && reportData.length > 0 && monthcardstab.current) {
      monthcardstab.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [loading, error, reportData]);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Box sx={{ display: 'flex' }}>
          <CircularProgress />
        </Box>
      </div>
    );
  }
  if (error) {
    return <div className="mainhead" align="center">Internal Error</div>;
  }
  
 if (reportData.length === 0) {
    return <div className="mainhead" align="center">No data found</div>;
  }

  // Pagination logic
  
  const paginatedData = rowsPerPage === 'all' 
    ? reportData 
    : reportData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    const totals = reportData.reduce(
      (acc, item) => {
        acc.total_cards += item.cards || 0;
        acc.tot_shops   +=item.shops || 0;
       acc.today_cards  +=item.avail_cards||0;
       acc.today_act_shops+=item.active_shops||0;
       acc.today_trans    +=item.avail_trans||0;
       acc.today_port_cards +=item.avail_port_cards||0;
       acc.manual_today_total +=item.manual_today||0;
       acc.tot_today_wheat    +=parseFloat(item.tot_today_wheat)||0;  
       acc.month_port_cards   +=item.port_month_cards||0;
       acc.manual_month_total +=item.manual_month||0;
       acc.tot_month_cards    +=item.month_cards||0;
       acc.tot_grand_per      +=parseFloat(item.tot_grand_per)||0.00;
        acc.tot_month_wheat   += parseFloat(item.tot_month_wheat)||0.00;

        return acc;
      },
      {
        total_cards: 0,
        tot_shops:0,
        today_cards:0,
        today_act_shops:0,
        today_trans:0,
        today_port_cards:0,
        manual_today_total:0,
        tot_today_wheat:0,
        month_port_cards:0,
        manual_month_total:0,
        tot_month_cards:0,
        tot_grand_per:0.00,
        tot_month_wheat:0.00,
       
      }
    );


  
   let tot_month_cards=totals.tot_month_cards;
   let tot_cards=totals.total_cards;
   let tt=(tot_month_cards/tot_cards)*100;
   let grand = tt.toFixed(2);

  return (
    
    <>
      <table ref={monthcardstab} align="center" width="100%" border={1}>
        <thead>
    
<tr class="tableheader">
				<th rowspan="3"><div align="center">Slno</div></th>
				<th rowspan="3"><div align="center">District</div></th>
				<th colspan="2"><div align="center">Total</div></th>
				<th colspan="6"><div align="center">Today</div></th>
				<th colspan="5"><div align="center">Current Month</div></th>
			</tr>
			<tr class="tableheader">
				<th rowspan="2"><div align="center">Cards</div></th>
				<th rowspan="2"><div align="center">Shops</div></th>
				<th rowspan="2"><div align="center">Active<br />Shops </div></th>
				<th rowspan="2"><div align="center">Trans</div></th>								
				<th colspan="3"><div align="center">Cards</div></th>
				<th rowspan="2"><div align="center">Wheat Lifted<br />(Qtl) </div></th>
				<th colspan="4"><div align="center">Cards</div></th>
				<th rowspan="2"><div align="center">Total Wheat<br />Lifted (Qtl)</div></th>
			</tr>
			<tr class="tableheader">
				<th><div align="center">Portability</div></th>
				<th><div align="center">Partial<br/>Offline</div></th>
				<th><div align="center">Total Avail</div></th>
				<th><div align="center">Portability</div></th>
				<th><div align="center">Partial<br/>Offline</div></th>
				<th><div align="center">Total Avail</div></th>				
				<th><div align="center">%</div></th>	
			</tr>
          <tr className="tableheader">
        
          </tr>
        </thead>
        <tbody>
          {paginatedData.map((item, index) => (
            <tr key={item.dist_code}>
              <td style={{ textAlign: 'center' }}>{rowsPerPage === 'all' ? index + 1 : index + 1 + page * rowsPerPage}</td> {/* Adjusted Sl.No */   }
              <td style={{ textAlign: 'left' }}>{item.dist_name_en}</td>
              <td style={{ textAlign: 'left' }}>{item.cards}</td>
              <td style={{ textAlign: 'right' }}>{item.shops}</td>
              <td style={{ textAlign: 'right' }}>{item.active_shops}</td>
              <td style={{ textAlign: 'right' }}>{item.avail_trans}</td>
              <td style={{ textAlign: 'right' }}>{item.avail_port_cards}</td>
              <td style={{ textAlign: 'right' }}>{item.manual_today}</td>
              <td style={{ textAlign: 'right' }}>{item.avail_cards}</td>
              <td style={{ textAlign: 'right' }}>{item.today_wheat}</td>
              <td style={{ textAlign: 'right' }}>{item.port_month_cards}</td>
              <td style={{ textAlign: 'right' }}>{item.manual_month}</td>
              <td style={{ textAlign: 'right' }}>{item.month_cards}</td>
              <td style={{ textAlign: 'right' }}>{item.trans_per}</td>
              <td style={{ textAlign: 'right' }}>{item.month_wheat}</td>

      
            </tr>
          ))}


          <tr className="tableheader">
              <td colSpan={2} style={{ textAlign: 'center', fontWeight: 'bold' }}>Total:</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.total_cards}</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.tot_shops}</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.today_act_shops}</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.today_trans}</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.today_port_cards}</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.manual_today_total}</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.today_cards}</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.tot_today_wheat.toFixed(2)}</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.month_port_cards}</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.manual_month_total}</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.tot_month_cards}</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{grand}</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.tot_month_wheat.toFixed(2)}</td>
              

          </tr>
        </tbody>
      </table>
      <br />
      <div align="Right"><span class="styleDate">Refreshed:{reportData[0].update_time} </span> <span class="styleTime"></span> </div>
      <br />
      <br />

      {/*
      <div width="75%" style={{display:'flex', justifyContent:'right',alignItems:'start' , width:'95%'}}> 
      <PaginationTable
        count={reportData.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      /></div>*/}
    </>
  );   
};

export default MonthAbstract_cards;

